import PageSeo from "@/components/PageSeo";

const Impressum = () => {
  return (
    <section className="pt-32 pb-24 px-6 max-w-3xl mx-auto">
      <PageSeo
        title="Impressum – Luther Club Kaiserslautern"
        description="Impressum und rechtliche Angaben des Luther Club Kaiserslautern, Martin-Luther-Straße 8."
        path="/impressum"
      />
      <h1 className="text-3xl md:text-4xl font-semibold text-primary mb-10">
        Impressum
      </h1>

      <div className="space-y-6 font-[Montserrat] text-sm text-foreground/80 leading-relaxed normal-case tracking-normal">
        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Angaben gemäß § 5 TMG</h2>
          <p>
            Luther Gastro GmbH &amp; Co. KG<br />
            Martin Luther Straße 8<br />
            67657 Kaiserslautern
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Vertreten durch</h2>
          <p>Luther Gastro GmbH &amp; Co. KG</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Kontakt</h2>
          <p>
            Telefon: 0174 2022890<br />
            E-Mail: <a href="mailto:info@luther-kl.com" className="text-primary hover:underline">info@luther-kl.com</a>
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Registereintrag</h2>
          <p>
            Eintragung im Handelsregister.<br />
            Registergericht: AG Kaiserslautern<br />
            Registernummer: 30634
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Umsatzsteuer</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
            DE19/656/41071
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
              https://ec.europa.eu/consumers/odr
            </a>.
          </p>
          <p className="mt-2">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          <p className="mt-2">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
            forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p className="mt-2">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
            bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
            konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
            diese Inhalte umgehend entfernen.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
            Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
            wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
            Zeitpunkt der Verlinkung nicht erkennbar.
          </p>
          <p className="mt-2">
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
            Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
            umgehend entfernen.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-foreground mb-2">Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p className="mt-2">
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
            beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
            von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Impressum;
